import React from "react";
import { useNavigate } from "react-router";

export function BackButton({ text , icon }) {
    const navigate = useNavigate();

    return (
        <span
            style={{ marginLeft: '5px' }}
            className="back-link"
            onClick={() => navigate(-1)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate(-1)}
        >
            <span className="back-icon">{icon}</span> {text}
        </span>
    );
}
